import {
  ParagraphData,
  ParagraphElement,
} from "@redotech/redo-model/forge/review-forge-types";
import { memo, useContext, useState } from "react";
import { RedoTextareaInputFieldTheme } from "../../arbiter-components/input/redo-textarea-input-field";
import { BrandKitTextAreaInput } from "../../brand-kit-text-area-input";
import { Flex } from "../../flex";
import { InspectorConfig } from "../../inspector";
import { Text } from "../../text";
import { BrandKitContext } from "../review-form-editor-contexts";

export const ReviewsParagraph = memo(function ReviewsParagraph({
  element,
  setData,
  data,
  showRequired,
}: {
  element: ParagraphElement;
  setData: (data: ParagraphData) => void;
  data?: ParagraphData;
  showRequired: boolean;
}) {
  const brandKit = useContext(BrandKitContext);

  const [value, setValue] = useState<string>("");

  function handleValueChange(value: string) {
    setValue(value);
    setData?.({ type: element.type, value });
  }

  const realValue = data?.value || value;

  const fontFamily = brandKit.font.bodyFontFamily; // NOTE: Assuming body font is used for paragraph

  const showRequiredState = showRequired && element.required;

  return (
    <Flex dir="column" style={{ fontFamily }}>
      <Text fontSize="sm" fontWeight="medium">
        {element.title}
      </Text>
      <BrandKitTextAreaInput
        brandKit={brandKit}
        placeholder={element.placeholderText}
        setValue={handleValueChange}
        theme={
          showRequiredState
            ? RedoTextareaInputFieldTheme.DESTRUCTIVE
            : RedoTextareaInputFieldTheme.DEFAULT
        }
        value={realValue}
      />
      {showRequiredState && (
        <Text fontSize="sm" textColor="error">
          This question is required
        </Text>
      )}
    </Flex>
  );
});

export const paragraphInspector: InspectorConfig<ParagraphElement> = {
  sections: [
    {
      label: "Paragraph",
      fields: [
        { widget: "toggle", path: "required", label: "Required" },
        { widget: "text", path: "title", label: "Title" },
        { widget: "text", path: "placeholderText", label: "Placeholder text" },
      ],
    },
  ],
};
